// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3_evK","buttons":"Footer_buttons__2pB2t"};